import isArray from "lodash/isArray";

import { IClassroom } from "../../classrooms";
import { EntityTypes } from "../../EntityTypes";
import { IUserResource } from "../../users";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalFilter, RelationalValue, mapRelationalValue, mapRelationalValueAsIRI } from "../../utils/filters";
import { IBrief } from "../types/IBrief";

export interface IBriefIndividualAssignMutationParameters {
    brief: RelationalValue<IBrief>;
    classroom: RelationalValue<IClassroom>;
    learners: RelationalFilter<IUserResource>;
}

export type IBriefIndividualAssignMutationResult = IBrief;

export const briefIndividualAssignMutation: IApiMutationFunction<IBriefIndividualAssignMutationParameters> = ({
    brief,
    classroom,
    learners,
}) => {
    return {
        method: "PATCH",
        url: `/briefs/${mapRelationalValue(brief)}/assignment`,
        headers: {
            "Content-Type": "application/merge-patch+json",
        },
        data: {
            classroomAssigned: mapRelationalValueAsIRI(EntityTypes.CLASSROOM, classroom),
            learnersAssigned: (isArray(learners) ? learners : [learners]).map(learner => ({
                uuid: mapRelationalValue(learner),
            })),
        },
    };
};

export const useBriefIndividualAssignMutation = createApiMutationHook<
    IBriefIndividualAssignMutationParameters,
    IBriefIndividualAssignMutationResult
>(briefIndividualAssignMutation);
